import type {
  DefaultContainerMaxWidth,
  StyledBootstrapGrid,
  PartialBreakpoints,
} from 'styled-bootstrap-grid/dist/components/ThemeProvider/types';
import { isNumber } from 'styled-bootstrap-grid/dist/utils';
import makeAliases from 'styled-bootstrap-grid/dist/aliases';
import type { MediaAliases } from 'styled-bootstrap-grid/dist/media/types';

interface GridTheme {
  breakpoints?: PartialBreakpoints;
  row?: {
    padding?: number;
  };
  col?: {
    padding?: number;
  };
  container?: {
    padding?: number;
    maxWidth?: PartialBreakpoints;
  };
  gridColumns?: number;
}

export const defaultContainerMaxWidth: DefaultContainerMaxWidth = {
  xxl: 1141,
  xl: 1140,
  lg: 960,
  md: 720,
  sm: 540,
  xs: 540,
};

/**
 * Don't modify. Copied from: https://github.com/dragma/styled-bootstrap-grid/blob/master/src/components/ThemeProvider/ThemeProvider.tsx.
 * @TODO implement our own `media[breakpoint] method to replace this`
 */
const gridThemeToStyledThemeProviderTheme = (gridTheme: GridTheme) => {
  const getContainerPadding = () => {
    if (isNumber(styledBootstrapGridTheme.container.padding)) {
      return styledBootstrapGridTheme.container.padding;
    }

    return 15;
  };

  const getContainerMaxWidth = (breakpoint: MediaAliases) => {
    if (isNumber(styledBootstrapGridTheme.container.maxWidth[breakpoint])) {
      return styledBootstrapGridTheme.container.maxWidth[breakpoint];
    }

    return defaultContainerMaxWidth[breakpoint];
  };

  const getRowPadding = () => {
    if (styledBootstrapGridTheme.row && isNumber(styledBootstrapGridTheme.row.padding)) {
      return styledBootstrapGridTheme.row.padding;
    }

    return 15;
  };

  const getColPadding = () => {
    if (styledBootstrapGridTheme.col && isNumber(styledBootstrapGridTheme.col.padding)) {
      return styledBootstrapGridTheme.col.padding;
    }

    return 15;
  };

  const getGridColumns = () => {
    if (styledBootstrapGridTheme && isNumber(styledBootstrapGridTheme.gridColumns)) {
      return styledBootstrapGridTheme.gridColumns;
    }

    return 12;
  };

  const styledBootstrapGridTheme: StyledBootstrapGrid = {
    gridColumns: gridTheme.gridColumns,
    breakpoints: makeAliases(gridTheme.breakpoints),
    col: gridTheme.col,
    row: gridTheme.row,
    container: {
      ...gridTheme.container,
      maxWidth: {
        ...makeAliases(defaultContainerMaxWidth),
        ...makeAliases((gridTheme.container || {}).maxWidth || {}),
      },
    },
    getContainerPadding,
    getContainerMaxWidth,
    getRowPadding,
    getColPadding,
    getGridColumns,
  };

  return { styledBootstrapGrid: styledBootstrapGridTheme };
};
export default gridThemeToStyledThemeProviderTheme;
